import React from 'react'
import { Link } from 'react-router-dom'

function ButtonTags() {
  return (
    <div>
      <footer className="ak-post-footer">
        <div className="ak-post-tags clearfix">
          <span>शब्द टुडे  पर पढ़े : </span>
          <Link to="/MadhyaPradesh-News">
            मध्य प्रदेश
          </Link>
          <Link to="/Chhattisgarh-News">
            छत्तीसगढ़
          </Link>
          <Link to="/Rashifal-News">
            राशिफल
          </Link>
          <Link to="/World-News">
            अंतरराष्ट्रीय
          </Link>
          <Link to="/Daram-News">
            धर्म
          </Link>
          <Link to="/Khel-News">
            खेल
          </Link>
          <Link to="/Webstorie-News">
            वेब स्टोरीज
          </Link>
          <Link to="/Bollywood-News">
            बॉलीवुड
          </Link>
        </div>
      </footer>
    </div>
  )
}

export default ButtonTags
